__turbopack_context__.v({
  "desktop": "responsive-container-module-scss-module__0HP1XG__desktop",
  "mobile": "responsive-container-module-scss-module__0HP1XG__mobile",
  "tabletLargeUp": "responsive-container-module-scss-module__0HP1XG__tabletLargeUp",
});
